const alphabet = '0123456789abcdefghijklmnopqrstuvwxyz';

function generate(size: number = 16) {
  return Array(size)
    .fill(null)
    .map(() => alphabet[Math.floor(Math.random() * alphabet.length)])
    .join('');
}

export const IdFuncs = {
  generate,
};
